import { Chakra } from "@airhelp/react-ui-components";

const { ListItem } = Chakra;

const Dots = () => <ListItem p={3}>&#8230;</ListItem>;

export default Dots;
